export default __webpack_public_path__ + "static/media/photo_framed-shelf.8c3e8e8a.jpg";